import { render, staticRenderFns } from "./StockShow.vue?vue&type=template&id=4a2ed7ba"
import script from "./StockShow.vue?vue&type=script&lang=js"
export * from "./StockShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports